<style scoped>
    .explanatory-text {
        font-size: 15px;
    }
</style>
<template>
    <v-dialog v-model="openDialog" max-width="600px">
        <v-card color="#F4FEFB">
            <v-card-title class="justify-center">
                <slot></slot>
            </v-card-title>
            <v-card-actions class="justify-center">
                <v-combobox
                    v-model="selectedItems"
                    :items="selectableItems"
                    chips
                    :clearable="clearable"
                    multiple
                    solo
                    hide-selected
                    item-text="name" item-value="id"
                    return-object
                    @input="inputComboBox" 
                    @change="changeComboBox"
                    @click:clear="clear"
                >
                    <template v-slot:selection="{ attrs, item, select, selected }">
                        <!-- 削除不可能な項目 -->
                        <v-chip v-if="getNonDeleteInGroup(item)"
                            v-bind="attrs"
                            :input-value="selected"
                            :color="nonDeleteColor"
                            :text-color="textColor"
                        >
                            <v-avatar left>
                                <v-icon>mdi-account-circle</v-icon>
                            </v-avatar>
                            <strong>{{ item.name }}</strong>
                        </v-chip>
                        <!-- 削除可能な項目 -->
                        <v-chip v-else
                            v-bind="attrs"
                            :input-value="selected"
                            :color="color"
                            :text-color="textColor"
                            close
                            @click="select"
                            @click:close="removeChip(item)"
                        >
                            <strong>{{ item.name }}</strong>
                        </v-chip>
                    </template>
                </v-combobox>
            </v-card-actions>
            <v-card-actions class="justify-center">
                <button-component color="blue-grey darken-1" @click="openDialog = false">キャンセル</button-component>
                <button-component color="red" @click="pushUpdate">更新</button-component>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    data() {
      return {
        // セレクトボックスの選択肢一覧
        selectableItems: [],
        // 追加した項目一覧
        selectedItems: [],
        // 直近に追加した項目
        currentAddItem: null,
      }
    },
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        // 選択済みの項目
        selecteds: {
            type: Array,
        },
        // 選択肢の項目
        selects: {
            type: Array,
        },
        // チップの色
        color: {
            type: String,
            default: "light-blue darken-1",
        },
        // 削除できないチップの色
        nonDeleteColor: {
            type: String,
            default: "red",
        },
        // 項目のテキスト色
        textColor: {
            type: String,
            default: "white",
        },
        // 全て削除✕ボタン
        clearable: {
            tyep: Boolean,
            default: false,
        },
        // 最後の1つのチップを削除可能にするか
        canDeleteLastChip: {
            tyep: Boolean,
            default: true,
        },
        // 削除不可能なグループのID
        nonDeleteGroupIds: {
            tyep: Array,
            default: () => ([]),
        }
    },
    created() {
        this.selectableItems = this.selects;
        this.selectedItems = this.selecteds;
        this.chipColor = this.color;
    },
    computed: {
        openDialog: {
            get() {
                return this.dialog
            },
            set(value) {
                this.$emit('update:dialog', value);
                // ダイアログを閉じるときに初期化
                this.nonDeleteGroupIds.length = 0;
                this.selectedItems.length = 0;
                this.selectableItems.length = 0;
            }
        },
    },
    methods: {
        inputComboBox(items) {
            if (items.length <= 0) {
                return;
            }
            let item = items[items.length - 1];
            if (!item.id) {
                // キーボード入力された値は除く
                items.pop();
            }
        },
        // コンボボックスの変更
        changeComboBox(items) {
            if (items.length <= 0) {
                return;
            }
            this.currentAddItem = items[items.length - 1];
            let res = [];
            for (let k in this.selectableItems) {
                if (this.selectableItems[k].id != this.currentAddItem.id) {
                    // 選択された項目を除いたセレクトボックスを作成
                    res.push(this.selectableItems[k]);
                }
            }
            this.selectableItems = res;
        },
        // チップの削除
        removeChip(item) {
            if (!this.canDeleteLastChip && this.selectedItems.length <= 1) {
                // 最後の1つのチップは削除しない
                return;
            }
            if (this.nonDeleteGroupIds.includes(item.id)) {
                // 削除不可項目に指定されている場合は削除しない
                return;
            }
            
            // 追加項目から削除
            this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
            // 選択肢から削除
            this.selectableItems.push(item);
        },
        // クリアボタン
        clear(items) {
            for (let k in this.selectedItems) {
                this.selectableItems.push(this.selectedItems[k]);
            }
            this.selectedItems.length = 0;
        },
        // 削除不可かの取得
        getNonDeleteInGroup(item) {
            if (this.nonDeleteGroupIds.length <= 0) {
                return;
            }
            let isNonDelete = this.nonDeleteGroupIds.includes(item.id);
            return isNonDelete;
        },
        // 更新ボタン
        pushUpdate() {
            this.$emit('updateGroup', this.selectedItems, this.selectableItems);
            this.openDialog = false;
        },
    },
}
</script>